<template>
  <div>
    <b-modal id="modalItems" data-backdrop="static" data-keyboard="false" size="xl" v-model="exibirItens" centered>
      <template #modal-header>
        <div class="w-100">
          <h5 class="col-12 row col-sm-3">
            {{ $t("Gerar Preditiva") }}
          </h5>
          <div class="row  d-flex justify-content-end align-items-center" style="padding: 0px 30px; justify-content: space-between">
            <div class="col-md-3 p-0 col-12 mr-3">
              <label>{{ $t("Planos Preventivos") }}</label>
              <v-select :options="objFiltroPlanos" @input="filtrarPlanos($event)" placeholder="Planos">
              </v-select>
            </div>
            <div class="col-md-3 p-0 col-12">
              <label>{{ $t("Filtro") }}</label>
              <v-select :options="objFiltro" @input="filtrarPlaca($event)" placeholder="Placas">
              </v-select>
            </div>
          </div>
        </div>
      </template>

      <b-table striped hover :items="arrayPlacas" :fields="fields" sticky-header="true">
        <template #cell(ACAO)="row">
          <div v-if="row.item.NR_SEQ_OS">
            <router-link :to="'os/' + row.item.NR_SEQ_OS" size="sm" class="mr-2 btn btn-success"
              style="padding: 0.25rem 0.5rem; font-size: 0.875rem">
              {{ $t("Acessar OS") }}
            </router-link>
          </div>
          <div v-if="!row.item.NR_SEQ_OS">
            <b-button @click="gerarOs(row.item)" size="sm" class="mr-2">
              {{ $t("Gerar OS") }}
            </b-button>
          </div>
        </template>
      </b-table>

      <template #modal-footer>
        <div class="w-100">
          <div class="row center" style="justify-content: center">
            <b-button class="mr-2" variant="danger" size="lg" @click="$emit('gerarPreditivas')">
              {{ $t("Fechar") }}
            </b-button>
          </div>
        </div>
      </template>
    </b-modal>
    <modal-fornecedores v-if="showModalFornec" :os="osFicticia" @saveFornec="enviaOsPreventivaExterna"
      @showModalFornec="showModalFornec = false"></modal-fornecedores>
  </div>
</template>
<script>
import ModalFornecedores from "./ModalFornecedores.vue";

export default {
  name: "ModalItems",
  props: {
    os: {},
    item: {}
  },
  data() {
    return {
      exibirItens: true,
      fields: [
        "ACAO",
        "PLACA",
        "PROXIMO_CICLO",
        "ULTIMA",
        "KM_ATUAL",
        "DS_PREDITIVO"
      ],
      arrayPlacas: [],
      arrayPlacasTemp: [],
      showModalFornec: false,
      objValuesOS: {},
      osFicticia: {
        nr_sequencial: 0
      },
      objFiltro: [],
      arrayPlanos: [],
      arrayPlanosTemp: [],
      objFiltroPlanos: [],
      exibeLista: true,
      valueGeralOs: ''
    };
  },
  components: {
    ModalFornecedores
  },
  methods: {
    enviaOsPreventivaExterna(nr_os, nr_seq_fornecedor) {
      const filial = this.$store.getters["filial/filial"];
      let value = this.valueGeralOs
      const ordemPreditiva = {
        nr_seq_fornecedor: nr_seq_fornecedor,
        placa: value.PLACA,
        cd_preventivo: value.CD_PREDITIVO,
        cdClifor: filial.tecnicoId,
        fornecedor: nr_seq_fornecedor
      };

      if (nr_seq_fornecedor == undefined) {
        this.$swal.fire({
          title: "Oops",
          text: "Selecione um fornecedor!",
          icon: "warning"
        });
        return false;
      }

      this.$store
        .dispatch("osItem/gerarPreditiva", { data: ordemPreditiva })
        .then(() => {
          this.$emit("showModalaVencer");
          window.location.reload();
          this.$swal.fire({
            title: "Sucesso",
            text: "Ordem gerada com sucesso!",
            icon: "success"
          });
        });

      // const cdClifor = this.$store.getters["filial/filial"];

      // if (nr_seq_fornecedor == undefined) {
      //   this.$swal.fire({
      //     title: "Oops",
      //     text: "Selecione um fornecedor!",
      //     icon: "warning"
      //   });
      //   return false;
      // }

      // const ordemServico = {
      //   nr_seq_fornecedor: nr_seq_fornecedor,
      //   placa: this.objValuesOS.PLACA,
      //   cdProxCiclo: this.objValuesOS.CD_PROX_CICLO,
      //   cdClifor: cdClifor.tecnicoId
      // };

      // this.$store
      //   .dispatch("osItem/gerarPreventiva", { data: ordemServico })
      //   .then(() => {
      //     this.$emit("showModalVencidas");
      //     this.$emit("refresh");
      //     this.$swal.fire({
      //       title: "Sucesso",
      //       text: "Ordem gerada com sucesso!",
      //       icon: "success"
      //     });
      //   });
    },
    filtrarPlaca(event) {
      console.log(this.arrayPlacasTemp);
      if (event) {
        let teste = 0;
        this.arrayPlacas = this.arrayPlacasTemp.filter(
          element => element.PLACA == event.PLACA
        );

      } else {
        this.arrayPlacas = this.arrayPlacasTemp;
      }
    },
    filtrarPlanos(event) {
      if (event) {
        let teste = 0;
        this.arrayPlacas = this.arrayPlacasTemp.filter(
          element => element.DS_PREDITIVO == event.DS_PREDITIVO
        );

      } else {
        this.arrayPlacas = this.arrayPlacasTemp;
      }
    },

    gerarOs(value) {
      this.valueGeralOs = value
      this.$swal
        .fire({
          title: "Qual é o tipo de OS?",
          text: "Você deseja direcionar esta OS como externa ou como interna?",
          icon: "warning",
          showCancelButton: true,
          cancelButtonColor: "#d33",
          cancelButtonText: "Interna",
          confirmButtonText: "Externa"
        })
        .then(result => {
          if (result.dismiss !== "backdrop") {
            if (result.value) {
              this.objValuesOS = value;
              this.showModalFornec = true;
            } else {
              const filial = this.$store.getters["filial/filial"];

              const ordemPreditiva = {
                nr_seq_fornecedor: 23,
                placa: value.PLACA,
                cd_preventivo: value.CD_PREDITIVO,
                cdClifor: filial.tecnicoId
              };

              this.$store
                .dispatch("osItem/gerarPreditiva", { data: ordemPreditiva })
                .then(() => {
                  this.$emit("showModalaVencer");
                  window.location.reload();
                  this.$swal.fire({
                    title: "Sucesso",
                    text: "Ordem gerada com sucesso!",
                    icon: "success"
                  });
                });
            }
          }
        })
        .catch(error => {
          console.log(error);
        });
    },

    getPlacasPreditivas() {
      let data = {};

      if (window.location.pathname == "/osPreditiva") {
        data.exibe_terminal = "N";
      } else if (window.location.pathname == "/osPredivitaArmazem") {
        data.exibe_terminal = "S";
      }

      this.$store
        .dispatch("osItem/getPlacasPreditivas", { data: data })
        .then(response => {
          let arrayPlaca = response.data;

          arrayPlaca.forEach(placa => {
            // const ano = placa.DATA.substring(0, 4)
            // const mes = placa.DATA.substring(5, 7)
            // const dia = placa.DATA.substring(8, 10)

            // const fullData = `${dia}/${mes}/${ano}`

            this.arrayPlacas.push({
              PLACA: placa.nr_placa,
              PROXIMO_CICLO: placa.proxima,
              ULTIMA: placa.ultima,
              // 'PROXIMO_KM': parseInt(placa.proxima).toLocaleString('pt-BR', { useGrouping: true, minimumFractionDigits: 0, maximumFractionDigits: 0 }),
              KM_ATUAL: parseInt(placa.km_atual).toLocaleString("pt-BR", {
                useGrouping: true,
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
              }),
              DS_PREDITIVO: placa.ds_preditivo,
              CD_PREDITIVO: placa.cd_preditivo,
              // 'CD_PROX_CICLO': placa.CD_PROX_CICLO,
              NR_SEQ_OS: placa.NR_SEQ_OS
            });
          });

          this.arrayPlacasTemp = this.arrayPlacas;

          // this.objFiltro = this.arrayPlacas.map(item => {
          //   return {
          //     ...item,
          //     label: item.PLACA
          //   };
          // });
          const placasUnicas = new Set();
          this.objFiltro = this.arrayPlacas
            .filter(item => {
              if (placasUnicas.has(item.PLACA)) {
                return false; // Já existe, então não adiciona
              }
              placasUnicas.add(item.PLACA);
              return true;
            })
            .map(item => ({
              ...item,
              label: item.PLACA
            }));

          const planosUnicos = new Set();

          this.objFiltroPlanos = this.arrayPlacas
            .filter(item => {
              if (planosUnicos.has(item.DS_PREDITIVO)) {
                return false; // Já existe, então não adiciona
              }
              planosUnicos.add(item.DS_PREDITIVO);
              return true;
            })
            .map(item => ({
              ...item,
              label: item.DS_PREDITIVO
            }));
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  computed: {
    placas() {
      const placas = this.$store.getters["osItem/placasAVencer"];

      if (!placas) {
        this.$store.dispatch("osItem/placasAVencer");

        return [];
      }

      return [placas];
    },
    items() {
      return this.$store.getters["osItem/items"];
    }
  },

  created() {
    this.getPlacasPreditivas();
  }
};
</script>
<style scoped>
  #modalItems {
    pointer-events: none !important;
    height: 750px !important;
  }

  .close {
    display: none !important;
  }

  #totalPecas {
    height: 435px !important;
    overflow-x: auto !important;
  }

  .modal-content {
    height: 700px !important;
  }

  .divGerar {
    border: 1px solid #c1c1c1;
  }
</style>
